import React from 'react'
import {Icon} from 'semantic-ui-react';

export default function Schedule(props) {
    let market = props.market;

    return (
        <div>
            {market.name}
            <div style={{
                paddingLeft: '15px',
                paddingBottom: '3px'
            }}>
            {
                market.selections.map((selection) => {
                    return (
                        <div style={{
                            display: 'flex',
                            fontSize: '90%'
                        }}>
                            <div style={{
                                flexGrow: 1,
                                flexShrink: 1,
                                whiteSpace: 'nowrap',
                                paddingRight: '5px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }}>{selection['name']}</div>
                            <div style={{
                                width: '40px',
                                flexShrink: 0,
                                whiteSpace: 'nowrap',
                                textAlign: 'right',
                                fontSize: '90%',
                                color: '#777777'
                            }}>{selection.odd[0]} <Icon name="caret right" /></div>
                            <div style={{
                                width: '40px',
                                flexShrink: 0,
                                textAlign: 'right'
                            }}>{selection.odd[1]}</div>
                        </div>
                    )
                })
            }
            </div>
        </div>
    )
}